import * as React from "react";
const SvgFiRrMars = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-mars_svg__a)">
      <path
        fill="#062147"
        d="M21.011 0h-4.98a.997.997 0 0 0 0 1.995h4.568l-6.805 6.817a8.484 8.484 0 0 0-11.93 1.41c-2.905 3.69-2.274 9.04 1.409 11.95a8.484 8.484 0 0 0 11.929-1.411 8.52 8.52 0 0 0 0-10.538l6.805-6.817v4.576a.997.997 0 1 0 1.992 0V2.993A2.99 2.99 0 0 0 21.012 0M8.56 21.95c-3.576 0-6.475-2.903-6.475-6.485S4.985 8.98 8.56 8.98c3.576 0 6.475 2.903 6.475 6.485-.005 3.58-2.901 6.481-6.475 6.485"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-mars_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMars;
